import { Link } from "react-router-dom";

export const LogoImg = ({ light = false, className = "h-14 w-auto" }) => (
  <img src={light ? "/img/logo-light.png" : "/img/logo.png"} alt="Home in Slovenia" className={className} width="600" height="521" />
);

export const Logo = ({ to, light = false, testid = "header-logo", className = "h-[60px] w-auto sm:h-[72px]" }) => (
  <Link to={to} className="flex items-center" data-testid={testid} aria-label="Home in Slovenia">
    <LogoImg light={light} className={className} />
  </Link>
);
